'use client';

import * as React from 'react';
import PropTypes from 'prop-types';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { cn } from '@helpers/styleUtils';

const ScrollArea = React.forwardRef(({ className, children, ...props }, ref) => (
    <ScrollAreaPrimitive.Root
        ref={ref}
        className={cn('relative overflow-hidden', className)}
        {...props}
    >
        <ScrollAreaPrimitive.Viewport className="h-full w-full rounded-[inherit]">
            {children}
        </ScrollAreaPrimitive.Viewport>
        <ScrollBar />
        <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

ScrollArea.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

const ScrollBar = React.forwardRef(({ className, orientation = 'vertical', ...props }, ref) => (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
        ref={ref}
        orientation={orientation}
        className={cn(
            'flex touch-none select-none transition-colors',
            orientation === 'vertical' && 'h-full w-1.5 border-l border-l-transparent p-[1px]',
            orientation === 'horizontal' && 'h-1.5 flex-col border-t border-t-transparent p-[1px]',
            className,
        )}
        {...props}
    >
        <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 rounded-full bg-black" />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

ScrollBar.propTypes = {
    className: PropTypes.string,
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
};

export { ScrollArea, ScrollBar };
